module.exports = __webpack_public_path__ + "img/battery.743fe993.svg";